import { render } from "./company-honor-image.vue?vue&type=template&id=17dfe337&scoped=true"
import script from "./company-honor-image.vue?vue&type=script&lang=js"
export * from "./company-honor-image.vue?vue&type=script&lang=js"

import "./company-honor-image.vue?vue&type=style&index=0&id=17dfe337&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dfe337"]])

export default __exports__